/**
 * Today's date in IST as 'YYYY-MM-DD'. The backend stamps all dates in IST,
 * so this is the canonical "today" for comparing against backend timestamps.
 * Using UTC (new Date().toISOString().slice(0,10)) is wrong between IST
 * midnight and 05:30, when the UTC date still points at the previous day.
 * `now` (optional) pins the instant -- tests, or an explicit reference date.
 */
export function getTodayIST(now = new Date()) {
  return now.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
}

/**
 * Converts a 'YYYY-MM-DD' string meant as an IST calendar date (e.g. from
 * getTodayIST() or a plain <input type="date">) into the correct UTC ISO
 * timestamp for 00:00:00 IST on that date — for sending to a backend that
 * expects UTC timestamps but treats dates as IST calendar days.
 *
 * Live-caught 2026-09-14: `new Date(dateStr).toISOString()` on a bare
 * 'YYYY-MM-DD' string is a DIFFERENT bug from getTodayIST()'s own (dates
 * this file already documents) — the JS spec parses a date-only ISO string
 * as UTC MIDNIGHT, not IST midnight, so a correctly-computed IST calendar
 * date still ends up serialized ~5.5h too late (into the *future*) whenever
 * "now" is between IST midnight and 05:30 IST. ABDM rejected a consent
 * request's dateRange.to for exactly this reason ("Date must be a
 * present/before date") even though the calendar date itself was correct.
 * Always use this helper instead of `new Date(dateStr).toISOString()` for
 * any IST-calendar-date-shaped string headed to an ABDM-facing payload.
 */
export function istDateToISOString(dateStr) {
  return new Date(`${dateStr}T00:00:00+05:30`).toISOString();
}
